import { render, staticRenderFns } from "./fbashipmentstracking.vue?vue&type=template&id=489bd673&"
import script from "./fbashipmentstracking.vue?vue&type=script&lang=js&"
export * from "./fbashipmentstracking.vue?vue&type=script&lang=js&"
import style0 from "./fbashipmentstracking.vue?vue&type=style&index=0&id=489bd673&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports